angular
  .module('resources.Subscriber', ['ngResource'])
  .factory('Subscriber', ['$resource', function ($resource) {
    var Resource = $resource('/api/admin/subscribers/:id', {id: '@_id'}, {
      query: {
        method: 'GET',
        isArray: false
      },
      update: {
        method: 'PUT'
      },
      search: {
        method: 'GET',
        url: '/api/admin/users-search',
        isArray: true
      },
      getAll: {
        method: 'GET',
        url: '/api/admin/subscribers',
        isArray: false
      }
    });

    return Resource;
  }]);



// WEBPACK FOOTER //
// ./client/src/common/resources/Subscriber.js